import { Box, Button } from '@mui/material'
import SearchRow from '@/components/SecondaryLeftNavigation/components/SearchRow'
import shared from '@/components/Settings/settingsShared.module.scss'

/**
 * Search plus the way in.
 *
 * Settings had no connect entry point at all — the app picker was reachable
 * only from the ask bar, so this page could list connections and never gain
 * one, which is the state every new account starts in.
 */
export default function ConnectionsDirectoryHeader({ query, onQueryChange, onAddApp }) {
  return (
    <Box className={shared.searchRowWrap} sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
      <Box sx={{ flex: 1, minWidth: 0 }}>
        <SearchRow value={query} onChange={onQueryChange} placeholder="Search connected apps" />
      </Box>
      {onAddApp ? (
        <Button size="small" variant="outlined" onClick={onAddApp}>
          Add app
        </Button>
      ) : null}
    </Box>
  )
}
